/**
 * 🟥 CUADRO NEGRO — GlobalUIContext (2026-07-06)
 *
 * Estado global de UI compartido en TODA la plataforma DamyxIA.
 * Contiene `deviceMode` (desktop | tablet | cell) para simular ancho
 * del contenedor principal de la sección abierta.
 *
 * Este contexto reemplaza semánticamente a WorkspaceContext pero
 * ambos comparten el mismo estado (se importa desde acá).
 */
import { createContext, useCallback, useContext, useState } from 'react';

const GlobalUIContext = createContext(null);

export const GlobalUIProvider = ({ children }) => {
  const [deviceMode, setDeviceMode] = useState('desktop');

  // Handler exacto del Cuadro Negro: máquina de estados cerrada.
  const handleDeviceSwitch = useCallback(() => {
    setDeviceMode((prev) => {
      if (prev === 'desktop') return 'tablet';
      if (prev === 'tablet') return 'cell';
      return 'desktop';
    });
  }, []);

  return (
    <GlobalUIContext.Provider value={{ deviceMode, setDeviceMode, handleDeviceSwitch }}>
      {children}
    </GlobalUIContext.Provider>
  );
};

export const useGlobalUI = () => {
  const ctx = useContext(GlobalUIContext);
  if (!ctx) {
    return { deviceMode: 'desktop', setDeviceMode: () => {}, handleDeviceSwitch: () => {} };
  }
  return ctx;
};

export default GlobalUIContext;
